<template>
    <div v-if="showMap" v-editable="blok" data-test="NewL4Map" class="l4-map-wrapper">
        <h2 class="font-semibold text-xl mb-1">{{ t('map') }}</h2>
        <ClientOnly>
            <LazyProductMap class="max-h-[370px]" :airport="airport" :products="products" />
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
import type { IL4Map } from '~/types/components/L4Map';
import type { IL4Airport } from '~/types/components/L4Airport';
import type { IL4ApiProductFull } from '~/types/components/L4Products';

const { blok } = defineProps<{ blok: IL4Map }>();
const { t } = useI18n();

const product = inject<Ref<IL4ApiProductFull>>('apiProduct');
const airport = inject<Ref<IL4Airport>>('airport');
const products = computed(() => [product?.value]);
const showMap = computed(() => {
    const isValidProductLatLng = product?.value?.latitude !== 0 && product?.value?.latitude !== 0;
    return !!(isValidProductLatLng || airport?.value);
});
</script>
